module.exports = __webpack_public_path__ + "img/9788991813298.14a24807.jpg";